#import "../../../../../../../../../../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query TravelerSecureRowLevels {
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
